import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { YourPersonalizedStartModal } from '../../../components/organisms/onboarding/modals/YourPersonalizedStart/YourPersonalizedStart';

const YourPersonalizedStart = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  // Use a useEffect to open the modal when the route is visited to create a smooth transition
  useEffect(() => {
    setIsOpen(true);
  }, [navigate]);

  return <YourPersonalizedStartModal opened={isOpen} onClose={() => navigate('..')} />;
};

export { YourPersonalizedStart };
